import Card from '@/components/base/card/card.component';
import CardHeader from '@/components/base/card/card-header.component';
import { CircularLoaderContainer } from '@/components/base/circular-loader-container.component';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from '@mui/material';
import { Receipt as ReceiptIcon } from '@mui/icons-material';
import dayjs from 'dayjs';
import { formatMoneyString } from '@/utils/format-money-string';
import { SapDocument } from '@/api/documents/documents.types.ts';

export default function Invoices({
  invoices,
  isPending,
}: {
  invoices: SapDocument[];
  isPending: boolean;
}) {
  if (isPending) {
    return (
      <Card elevation={2}>
        <CardHeader title="Rechnungen" />
        <CircularLoaderContainer />
      </Card>
    );
  }
  if (invoices.length === 0) {
    return null;
  }

  return (
    <Card elevation={2} sx={{ borderRadius: 3, overflow: 'hidden' }}>
      <CardHeader icon={<ReceiptIcon />} title="Rechnungen" />
      <TableContainer>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>Rechnungsnummer</TableCell>
              <TableCell>Datum</TableCell>
              <TableCell>Betrag</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {invoices.map((item) => (
              <TableRow key={item.docNum}>
                <TableCell>{item.docNum}</TableCell>
                <TableCell>
                  {dayjs(item.docDate).format('DD.MM.YYYY')}
                </TableCell>
                <TableCell>{formatMoneyString(item.docTotal)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Card>
  );
}
